const P = "https://images.pexels.com/photos";
const U = "https://images.unsplash.com";

export const HERO_SLIDES = [
  {
    url: `${P}/8940466/pexels-photo-8940466.jpeg?auto=compress&cs=tinysrgb&w=1800`,
    caption: "High-precision stainless steel laboratory equipment, manufactured end-to-end in our facility.",
  },
  {
    url: `${U}/photo-1748002388689-c62b45d5c28b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800`,
    caption: "ISO-certified cleanroom assembly and calibration operations.",
  },
  {
    url: `${P}/34642915/pexels-photo-34642915.jpeg?auto=compress&cs=tinysrgb&w=1800`,
    caption: "Environmental test chambers and clinical analyzers, built to order.",
  },
];

export const FACILITY = {
  cleanroom: `${U}/photo-1748000970909-845f4aa144d2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400`,
  qc: `${P}/5118462/pexels-photo-5118462.jpeg?auto=compress&cs=tinysrgb&w=1200`,
  rnd: `${U}/photo-1581093577421-f561a654a353?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200`,
  fab: `${P}/8442538/pexels-photo-8442538.jpeg?auto=compress&cs=tinysrgb&w=1200`,
};

const g = (url, title, category) => ({ url, title, category });

export const GALLERY = [
  g(FACILITY.cleanroom, "Cleanroom Manufacturing Facility", "Cleanroom"),
  g(FACILITY.qc, "Quality Testing & Calibration Bay", "Quality Control"),
  g(FACILITY.rnd, "In-House R&D Testing Station", "R&D"),
  g(FACILITY.fab, "Precision Sheet Metal Fabrication", "Manufacturing"),
  g(HERO_SLIDES[0].url, "Assembly Line — Stainless Steel Fabrication", "Manufacturing"),
  g(HERO_SLIDES[1].url, "Sterile Assembly Operations", "Cleanroom"),
  g(HERO_SLIDES[2].url, "Environmental Test Chambers — Installed", "Installed Units"),
  g(`${U}/photo-1657778752468-900eb89c225e?crop=entropy&cs=srgb&fm=jpg&q=85&w=900`, "Autoclave Units — Ready for Dispatch", "Installed Units"),
  g(`${U}/photo-1657778753022-ccdb15b28eb4?crop=entropy&cs=srgb&fm=jpg&q=85&w=900`, "BOD Incubator Bank at a Client Lab", "Installed Units"),
  g(`${U}/photo-1669344319065-61282714d7ce?crop=entropy&cs=srgb&fm=jpg&q=85&w=900`, "Water Bath Line — Final Inspection", "Quality Control"),
  g(`${U}/photo-1663354876870-6282cb0a8843?crop=entropy&cs=srgb&fm=jpg&q=85&w=900`, "Humidity Chamber Under Test", "R&D"),
  g(`${P}/6627667/pexels-photo-6627667.jpeg?auto=compress&cs=tinysrgb&w=900`, "Deep Freezer Storage Systems", "Installed Units"),
];

export const GALLERY_CATS = ["All", "Manufacturing", "Quality Control", "Cleanroom", "R&D", "Installed Units"];
